import { render, staticRenderFns } from "./ProjectResumedLifecycleSetter.vue?vue&type=template&id=11d08608"
import script from "./ProjectResumedLifecycleSetter.vue?vue&type=script&lang=ts"
export * from "./ProjectResumedLifecycleSetter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports